import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'out-success',
  imports: [CommonModule],
  templateUrl: './success.component.html',
  styleUrl: './success.component.scss',
})
export class SuccessComponent implements OnInit {
  transactionId = '';

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    // Get transaction ID from URL params if available
    this.route.queryParams.subscribe((params) => {
      this.transactionId = params['session_id'] || 'N/A';
    });
  }

  goToHome() {
    this.router.navigate(['/account']);
  }

  viewListing() {
    this.router.navigate(['/used-tesla-for-sale']);
  }
}
